import type { ElementType, ReactNode } from 'react'
import { useState } from 'react'
import Debug from 'debug'

import { useElementSizeCallback, useThrottle } from '@jotta/hooks'
import type { Rect } from '@jotta/types/Dimensions'
import { cn } from '@jotta/utils/css'
const log = Debug('jotta:ui:AnimateHeight')

export function AnimateHeight({
  className,
  innerClassName,
  children,
}: {
  className?: string
  innerClassName?: string
  children: ReactNode
}) {
  const [height, setHeight] = useState(-1)
  const [ref, setRef] = useState<HTMLDivElement | null>() // useState() instead of useRef() to ensure re-rendering is triggered

  const throttledCallback = useThrottle(
    (rect: Rect) => {
      const { height } = rect
      setHeight(height)
      log(height)
    },
    30,
    { leading: false, trailing: true },
  )

  useElementSizeCallback(ref, throttledCallback)

  return (
    <div
      className={cn('overflow-hidden transition-[height]', className)}
      style={{
        height: height >= 0 ? height : 'auto',
      }}
    >
      <div ref={setRef} className={innerClassName}>
        {children}
      </div>
    </div>
  )
}
